import { LuCheck } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useLinkBadgeConfirmed from './link-badge-confirmed.controller';

const ID = 'link-badge-confirmed';

const LinkBadgeConfirmed = () => {
    const viewProps = useLinkBadgeConfirmed();

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onSubmit: viewProps.onContinue
            }}>
            <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
                <div className='bg-status-success relative flex size-24 items-center justify-center rounded-full'>
                    <LuCheck className='text-always-white size-16' />
                </div>

                <div className='text-foreground-default text-xl font-semibold'>
                    <FormattedMessage
                        id='kiosk.wizard.link-badge-confirmed.title'
                        defaultMessage='Badge linked'
                        description='Title shown when a badge has been successfully linked to a user on the kiosk'
                    />
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default LinkBadgeConfirmed;
